import { actions as additionalUsersActions } from 'app/store/ducks/additional-users/actions';
import { actions as authActions } from 'app/store/ducks/auth/actions';
import { getCurrentUser } from 'app/utils/currentUser';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useStyles } from './styles';

import { KeyboardArrowDownOutlined } from '@material-ui/icons';
import emailIcon from 'app/assets/images/icons/email-icon.svg';
import { ModalConfirm } from 'app/components/Common/ModalConfirm';
import { Button, ButtonTypes } from 'app/components/Material/Inputs/Button';
import { Menu } from 'app/components/Material/Menu';
import { ProgressBar } from 'app/components/Material/ProgressBar';
import clsx from 'clsx';
import { TeamHeader } from './components/TeamHeader';
import { TeamSkeletonLoading } from './components/TeamSkeletonLoading';
import { InviteModal } from './components/inviteModal';
import { Auth } from 'aws-amplify';
import { useHistory } from 'react-router-dom';

export const ROLE = ['Admin', 'Member', 'View only'];

const roleMenu = [
  {
    role_id: 1,
    label: 'Admin',
    content: 'Can modify billing information and manage team members',
  },
  {
    role_id: 2,
    label: 'Member',
    content: 'Can make updates to projects and modify connections',
  },
  {
    role_id: 3,
    label: 'View only',
    content: 'Can perform searches and view information on projects',
  },
];

const Team = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const userDetails = useSelector((state) => state.auth.userDetails);
  const user = useSelector((state) => state.auth.user);
  const { additionalUsers, loading } = useSelector(
    (state) => state.additionalUsers,
  );

  const [showInviteModal, setShowInviteModal] = useState(false);
  const [role, setRole] = useState(roleMenu[0]);
  const [email, setEmail] = useState('');
  const [showLoading, setShowLoading] = useState(true);
  const [roleClick, setRoleClick] = useState();
  const [anchorEl, setAnchorEl] = useState();
  const [openRemoveModal, setOpenRemoveModal] = useState(false);
  const [typeRemove, setTypeRemove] = useState('');
  const [itemRemove, setItemRemove] = useState();

  const [showMissingNameModal, setShowMissingNameModal] = useState(false);

  const currentUser = getCurrentUser(userDetails);

  useEffect(() => {
    dispatch(authActions.fetchUserDetails());
    dispatch(additionalUsersActions.getUsers());
  }, [dispatch]);

  const handleOpenInviteModal = () => {
    Auth.currentAuthenticatedUser()
      .then(user => {
        // Check for missing family_name or given_name
        const { attributes } = user;
        if (
          !attributes?.family_name ||
          !attributes?.given_name
        ) {
          setShowMissingNameModal(true);
        } else {
          setShowInviteModal(true);
        }
      });
  };

  const handleCloseInviteModal = () => {
    setShowInviteModal(false);
  };

  const onChangeRole = (value) => {
    setRole(value);
  };

  const handleInvite = () => {
    const payload = {
      email,
      role_id: role.role_id,
    };
    dispatch(additionalUsersActions.addUser(payload));
    setEmail('');
    handleCloseInviteModal();
  };

  const onChangeEmail = (e) => {
    setEmail(e.target.value);
  };

  const onClickRole = (e, item) => {
    setRoleClick(item);
    setAnchorEl(e.currentTarget);
  };

  const handleCloseRoleMenu = () => {
    setRoleClick();
    setAnchorEl();
  };

  const handleUpdateRole = (role_id) => {
    if (role_id !== roleClick.role_id) {
      dispatch(
        additionalUsersActions.updateUser({ id: roleClick.id, role_id }),
      );
    }
    handleCloseRoleMenu();
  };

  const handleRemove = (id) => {
    dispatch(additionalUsersActions.removeUser({ id }));
  };

  const handleClickRemove = (id, type) => {
    setItemRemove(id);
    setTypeRemove(type);
    setOpenRemoveModal(true);
  };

  useEffect(() => {
    let progressTimeoutId;
    if (loading) {
      setShowLoading(true);
    } else {
      progressTimeoutId = setTimeout(() => {
        setShowLoading(false);
      }, 500);
    }
    return () => {
      clearTimeout(progressTimeoutId);
    };
  }, [loading]);

  const handleMissingNameModalConfirm = () => {
    setShowMissingNameModal(false);
    history.push('/settings/user-profile');
  };

  return (
    <div>
      <div className={classes.header}>
        <div className={classes.headerLabel}>Team</div>
        <Button
          onClick={() => window.open('https://help.datarova.com/en/', '_blank')}
          type={ButtonTypes.ghostSmall}
          iconLeft="info"
          hideChildren={true}
          showBorder={true}
        >
          Info
        </Button>
      </div>
      {showLoading ? (
        <>
          <ProgressBar
            loading={loading}
            showLoading={showLoading}
            hideIndicator={true}
          />
          <TeamSkeletonLoading loading={loading} showLoading={showLoading} />
        </>
      ) : (
        <div className={classes.teamContainer}>
          <TeamHeader handleOpenInviteModal={handleOpenInviteModal} />
          <div className={classes.teamContent}>
            <div className={classes.table}>
              <div className={classes.tableItem}>
                <div className={classes.colLeft}>
                  <div className={classes.avatar}>
                    {currentUser?.accountName?.charAt(0)?.toUpperCase()}
                  </div>
                  <div className={classes.nameGroup}>
                    <div className={classes.name}>
                      <span>
                        {currentUser?.firstName || user?.given_name || ''}
                      </span>
                      {!currentUser?.parentUserEmail && (
                        <span className={classes.tagName}>You</span>
                      )}
                    </div>
                    <div className={classes.email}>
                      {currentUser?.parentUserEmail
                        ? currentUser?.parentUserEmail
                        : user?.email || ''}
                    </div>
                  </div>
                </div>
                <div className={classes.colRight}>
                  <div className={classes.owner}>Owner</div>
                  <div></div>
                </div>
              </div>
              {additionalUsers?.length > 0 &&
                additionalUsers?.map((item) =>
                  item.status === 'pending' ? (
                    <div key={item.id} className={clsx(classes.tableItem, classes.row)}>
                      <div className={classes.colLeft}>
                        <div className={classes.avatarEmail}>
                          <img src={emailIcon} alt="" />
                        </div>
                        <div className={classes.nameGroup}>
                          <div className={classes.email}>{item.email}</div>
                        </div>
                      </div>
                      <div className={classes.colRight}>
                        <div className={classes.invitePending}>
                          Invite pending
                        </div>
                        <Button
                          onClick={() => handleRemove(item.id)}
                          type={ButtonTypes.ghost}
                        >
                          Delete
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <div key={item.id} className={clsx(classes.tableItem, classes.row)}>
                      <div className={classes.colLeft}>
                        <div className={classes.avatar}>
                          {item.firstName?.charAt(0)?.toUpperCase()}
                        </div>
                        <div className={classes.nameGroup}>
                          <div className={classes.name}>
                            <span>{item.firstName}</span>
                            {user.email === item.email && (
                              <span className={classes.tagName}>You</span>
                            )}
                          </div>
                          <div className={classes.email}>{item.email}</div>
                        </div>
                      </div>
                      <div className={classes.colRight}>
                        <Button
                          onClick={(e) => onClickRole(e, item)}
                          type={ButtonTypes.ghost}
                        >
                          <span className={classes.buttonRole}>
                            <span>{ROLE[item.role_id - 1]}</span>
                            <KeyboardArrowDownOutlined />
                          </span>
                        </Button>
                        <Button
                          onClick={() =>
                            handleClickRemove(
                              item.id,
                              user.email === item.email ? 'leave' : 'remove',
                            )
                          }
                          type={ButtonTypes.ghost}
                        >
                          {user.email === item.email ? 'Leave' : 'Remove'}
                        </Button>
                      </div>
                    </div>
                  ),
                )}
            </div>
          </div>
        </div>
      )}

      <InviteModal
        show={showInviteModal}
        handleClose={handleCloseInviteModal}
        role={role}
        onChangeRole={onChangeRole}
        handleInvite={handleInvite}
        email={email}
        onChangeEmail={onChangeEmail}
        roleMenu={roleMenu}
      />
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseRoleMenu}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        className={classes.menuRoleModal}
        withMobileView={true}
      >
        {roleMenu.map((item, index) => (
          <div
            key={index}
            className={classes.roleItem}
            onClick={() => handleUpdateRole(item.role_id)}
          >
            <div className={classes.roleLabel}>{item.label}</div>
            <div className={classes.roleContent}>{item.content}</div>
          </div>
        ))}
      </Menu>
      <ModalConfirm
        open={openRemoveModal}
        handleCancel={() => setOpenRemoveModal(false)}
        title={typeRemove === 'leave' ? 'Leave Account' : 'Remove User'}
        summary={
          typeRemove === 'leave' ? (
            <>
              <span>Are you sure you want to leave this account?</span>
              <br />
              <span>
                If you leave then you'll no longer have access to this account.
              </span>
            </>
          ) : (
            <>
              <span>
                Are you sure you want to remove this user from the account?
              </span>
              <br />
              <span>
                The user will no longer have access to the account if they are
                removed.
              </span>
            </>
          )
        }
        handleConfirm={() => {
          handleRemove(itemRemove);
          setItemRemove();
          setTypeRemove();
          setOpenRemoveModal(false);
        }}
        confirmTitle="Confirm"
      />
      <ModalConfirm
        open={showMissingNameModal}
        handleCancel={() => setShowMissingNameModal(false)}
        title="Missing Profile Information"
        summary={
          <>
            <span>
              Your profile is missing required information (first name or last name).
            </span>
            <br />
            <span>
              Please update your profile to continue.
            </span>
          </>
        }
        handleConfirm={handleMissingNameModalConfirm}
        confirmTitle="OK"
        cancelTitle=""
      />
    </div>
  );
};

export default Team;
